import { ProductPageLayout } from '../components/ProductPageLayout';

export function VideoGenPage() {
    return <ProductPageLayout productId="video-gen" />;
}
